'use client';

import { usePathname } from 'next/navigation';
import DynamicJsonLd from './dynamic-json-ld';

export default function ContactSeo() {
  const pathname = usePathname();

  // For contact page, we'll include the local business schema
  return <DynamicJsonLd type='localBusiness' pathname={pathname} />;
}
